export const authorGenders = [
  {
    label: "Female",
    value: "Female"
  },
  {
    label: "Male",
    value: "Male"
  },
  {
    label: "Nonbinary",
    value: "Nonbinary"
  }
];

export const authorEthnicities = [
  {
    label: "Asian",
    value: "Asian"
  },
  {
    label: "Black or African American",
    value: "Black or African American"
  },
  {
    label: "Hispanic or LatinX",
    value: "Hispanic or LatinX"
  },
  {
    label: "Indigenous Australian",
    value: "Indigenous Australian"
  },
  {
    label: "Middle Eastern",
    value: "Middle Eastern"
  },
  {
    label: "Native American or Alaska Native",
    value: "Native American or Alaska Native"
  },
  {
    label: "Native Hawaiian or other Pacific Islander",
    value: "Native Hawaiian or other Pacific Islander"
  },
  {
    label: "White",
    value: "White"
  }
];
